export class ButtonConfig {

    constructor(enable: boolean = true, visible: boolean = true){
        this.Enable = enable;
        this.Visible = visible;
    }

    Enable: boolean=true;
    Visible: boolean=true;

}
